export function gpsNavLink(loc: Array<number>) {
  return `http://maps.google.com/maps?q=loc:${loc[1]},${loc[0]}&navigate=yes`;
}
